import { Search, Globe, Hash, FileText } from 'lucide-react';

const INDICATORS = [
  { type: 'IPv4', value: '45.33.32.156', confidence: 92, source: 'CISA KEV', lastSeen: '2026-05-12 14:00' },
  { type: 'Domain', value: 'malware-c2.exfil.example.com', confidence: 88, source: 'MISP', lastSeen: '2026-05-12 10:30' },
  { type: 'SHA256', value: 'a1b2c3d4e5f6...a9b0c1d2e3f4', confidence: 95, source: 'AlienVault OTX', lastSeen: '2026-05-12 09:15' },
  { type: 'IPv4', value: '192.168.1.105', confidence: 45, source: 'Internal', lastSeen: '2026-05-12 14:32' },
  { type: 'Domain', value: 'phish-payload.cdn.example.net', confidence: 78, source: 'NCSC', lastSeen: '2026-05-11 22:00' },
  { type: 'MD5', value: 'd4e5f6a7b8c9...f1e2d3c4b5a6', confidence: 83, source: 'MITRE ATT&CK', lastSeen: '2026-05-11 18:45' },
  { type: 'IPv4', value: '103.21.244.15', confidence: 67, source: 'MyCERT', lastSeen: '2026-05-11 14:20' },
  { type: 'SHA1', value: 'b1c2d3e4f5a6...d4e5f6a7b8c9', confidence: 91, source: 'CISA KEV', lastSeen: '2026-05-10 08:00' },
];

const TYPE_ICONS = {
  IPv4: Globe,
  Domain: Globe,
  SHA256: Hash,
  MD5: Hash,
  SHA1: Hash,
};

const IndicatorVault = () => (
  <div className="p-6 space-y-6">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-white">Indicator Vault</h1>
      <p className="text-sm text-gray-500 mt-1">
        Searchable database of IPs, Domains, and Hashes · PRD: INTEL (Section 7.8)
      </p>
    </div>

    <div className="bg-gray-900 border border-gray-700/50 rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Search className="w-5 h-5 text-cyan-400" />
          <h2 className="text-lg font-semibold text-white">Indicators of Compromise</h2>
        </div>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/20 text-cyan-400 border border-cyan-500/30">
          Coming Soon
        </span>
      </div>

      <div className="relative mb-6">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-600" />
        <input
          type="text"
          placeholder="Search indicators by value, type, or source..."
          className="w-full bg-gray-950 border border-gray-700 rounded-lg pl-10 pr-4 py-2.5 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-cyan-400/50 transition-colors"
          disabled
        />
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-gray-500 uppercase text-xs border-b border-gray-700/50">
              <th className="text-left py-3 pr-4 font-medium">Type</th>
              <th className="text-left py-3 pr-4 font-medium">Value</th>
              <th className="text-left py-3 pr-4 font-medium">Confidence</th>
              <th className="text-left py-3 pr-4 font-medium">Source</th>
              <th className="text-left py-3 font-medium">Last Seen</th>
            </tr>
          </thead>
          <tbody className="text-gray-400">
            {INDICATORS.map((ind, i) => {
              const Icon = TYPE_ICONS[ind.type] || FileText;
              return (
                <tr key={i} className="border-b border-gray-800/50 hover:bg-gray-800/30 transition-colors">
                  <td className="py-3 pr-4">
                    <div className="flex items-center gap-1.5">
                      <Icon className="w-3.5 h-3.5 text-gray-600" />
                      <span className="px-2 py-0.5 rounded text-xs font-mono bg-gray-800 text-gray-300">{ind.type}</span>
                    </div>
                  </td>
                  <td className="py-3 pr-4 font-mono text-xs text-white">{ind.value}</td>
                  <td className="py-3 pr-4">
                    <div className="flex items-center gap-2">
                      <div className="w-12 h-1.5 bg-gray-800 rounded-full overflow-hidden">
                        <div
                          className={`h-full rounded-full ${
                            ind.confidence >= 80 ? 'bg-red-400' :
                            ind.confidence >= 60 ? 'bg-amber-400' :
                            'bg-emerald-400'
                          }`}
                          style={{ width: `${ind.confidence}%` }}
                        />
                      </div>
                      <span className="font-mono text-xs">{ind.confidence}%</span>
                    </div>
                  </td>
                  <td className="py-3 pr-4">{ind.source}</td>
                  <td className="py-3 font-mono text-xs text-gray-500">{ind.lastSeen}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default IndicatorVault;
